import { FunctionComponent } from 'react'

import styled from 'styled-components'

import FreeRatioImage from '@components/FreeRatioImage'

const StyledQRCode = styled(FreeRatioImage)`
  flex-shrink: 0;
`

const IMAGE = {
  src: '/incoming/21351289-v0-qr-code-onsite-onboarding.png',
  alt: 'qr-code',
  width: 800,
  height: 800,
  crops: {},
} as const

const expectedDimensions = { width: 175, height: 175 } as const

const constraints = {
  desktop: expectedDimensions,
  tablet: expectedDimensions,
  mobile: expectedDimensions,
  mobileSmall: expectedDimensions,
} as const

const QRCode: FunctionComponent = () => (
  <StyledQRCode
    src={IMAGE.src}
    alt={IMAGE.alt}
    crops={IMAGE.crops}
    originalDimensions={{
      width: IMAGE.width,
      height: IMAGE.height,
    }}
    constraints={constraints}
  />
)
export default QRCode
